// @flow
import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import { CustomView, isMobileOnly } from 'react-device-detect';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Wrapper, svgStyle } from './style';
import { optionsPlatforms } from '../../pages/AdvancedSearch';
import ChevronOuvre from '../../assets/images/chevron_ouvre.svg';
import Cadenas from '../../assets/images/cadenas_simple.png';
import CadenasFerme from '../../assets/images/cadenas_exclusif.png';
import CircleCheck from '../../assets/images/circle-check-solid.svg';
import CircleXmark from '../../assets/images/circle-xmark-solid.svg';
import SearchAPI from '../../library/SearchAPI';

import type { Select } from '../../types/Select';

type Props = any;

type State = {
  displayOverview: boolean,
  permissions: ?boolean,
  formats: Array<string>
};

const titleSliceAt = 65;
const subtitleSliceAt = 45;
const siteTitleSliceAt = 70;

class ResultCard extends Component<Props, State> {
  state = {
    displayOverview: false,
    permissions: null,
    formats: []
  };

  componentDidMount() {
    this.loadPermission();
  }

  loadPermission = async () => {
    const { via, url, platformID } = this.props;

    if (
      via === 'exclusive' ||
      platformID === 'OB' ||
      platformID === 'OJ'
    ) {
      const searchParams = new URLSearchParams(window.location.search);
      const response = await SearchAPI.getPermissions([url], platformID || 'OB');
      if (response.data.docs) {
        this.setState({
          permissions: response.data.docs[0].isPermitted,
          formats: response.data.organization['formats'] || []
        });
      } else {
        this.setState({
          permissions: false,
          formats: []
        });
      }
    }
  };

  getColor = () => {
    switch (this.props.platformID) {
      case 'OB':
        return '#B73288';
      case 'OJ':
        return '#0BB7D9';
      case 'HO':
        return '#EC5A4F';
      case 'CO':
        return '#8DBE1E';
      default:
        return 'black';
    }
  };

  getTitleColor = () => {
    switch (this.props.platformID) {
      case 'OB':
        return '#9B2470';
      case 'OJ':
        return '#176EA1';
      case 'HO':
        return '#CC071E';
      case 'CO':
        return '#3B7A12';
      default:
        return 'black';
    }
  };

  getBorderBottomColor = () => {
    switch (this.props.platformID) {
      case 'OB':
        return '#E7BAD8';
      case 'OJ':
        return '#B0DFE9';
      case 'HO':
        return '#F3BAC1';
      case 'CO':
        return '#BFDD7D';
      default:
        return 'black';
    }
  };

  handleClickOverview = (event: any): void => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ displayOverview: !this.state.displayOverview });
  };

  handleClickCard = () => {
    const { url } = this.props;

    window.open(url);
  };

  render() {
    const {
      title: _title,
      subtitle: _subtitle = '',
      type,
      platformID,
      authors: authorsRequeted = [],
      site_title = '',
      date,
      overview,
      via,
      translations,
      subscribers
    } = this.props;
    const { displayOverview, permissions } = this.state;
    const contributeurFacetR_auteur =
      authorsRequeted !== null ? authorsRequeted : [];

    const authors = contributeurFacetR_auteur.slice(0, 4).map(author => {
      const explode = author.split(', ');

      const firstNames = explode[1] ? explode[1].split('-') : [];

      const firstName =
        firstNames.length === 1
          ? `${firstNames[0].slice(0, 1)}.`
          : firstNames.length !== 0
            ? `${firstNames.map(i => i.slice(0, 1)).join('-')}.`
            : '';

      return `${explode[0]} ${firstName}`;
    });

    const supAuthors =
      contributeurFacetR_auteur.length > 4 ? (
        <span>
          {' '}
          <FormattedMessage id="resultCard.et_al" />
        </span>
      ) : (
        ''
      );

    const platform: void | Select = optionsPlatforms.find(
      (l: Select) => l.value === platformID
    );

    const label = platform ? platform.label : 'Unknown platform';
    const _site_titleFormatted = site_title
      .replace(/&amp;/g, '&')
      .replace(/&#160;/g, ' ')
      .replace(/<\/?sup>/gm, '');
    const title =
      _title && _title.length > titleSliceAt
        ? `${_title.slice(0, titleSliceAt - 3)}...`
        : _title;
    const subtitle =
      _subtitle && _subtitle.length > subtitleSliceAt
        ? `${_subtitle.slice(0, subtitleSliceAt - 3)}...`
        : _subtitle;
    const site_titleFormatted =
      _site_titleFormatted && _site_titleFormatted.length > siteTitleSliceAt
        ? `${_site_titleFormatted.slice(0, siteTitleSliceAt - 3)}...`
        : _site_titleFormatted;

    const renderAvail = () => {
      if (via === 'exclusive' && permissions === null)
        return <FormattedMessage id="resultCard.loading_permissions" />;

      return (
        <div className="access">
          <div className="access__image">
            <img
              className={`access__image__img ${via}`}
              src={
                via === 'exclusive' || via === 'embargo'
                  ? CadenasFerme
                  : Cadenas
              }
              alt={`${via} access`}
              loading="lazy"
            />
          </div>
          <div className="access__format html">
            <p className="access__format__label">HTML</p>
            <img
              className={`access__image__img ${via}`}
              src={
                (permissions && this.state.formats.includes('html')) ||
                via === 'freemium' ||
                via === 'openaccess'
                  ? CircleCheck
                  : CircleXmark
              }
              alt="Accès ouvert"
              loading="lazy"
            />
          </div>
          {['OB', 'OJ', 'CO'].includes(this.props.platformID) && (
            <div className="access__format pdf_epub">
              <p className="access__format__label">PDF / ePub</p>
              <img
                className={`access__image__img ${via}`}
                src={
                  (permissions &&
                    (this.state.formats.includes('pdf') ||
                      this.state.formats.includes('epub'))) ||
                  via === 'openaccess'
                    ? CircleCheck
                    : CircleXmark
                }
                alt="Accès ouvert"
                loading="lazy"
              />
            </div>
          )}
        </div>
      );
    };

    return (
      <Wrapper>
        <a href={this.props.url} className="card-link">
          <div className="header" style={{ borderColor: this.getColor() }}>
            {label}
          </div>

          <CustomView
            condition={!isMobileOnly}
            viewClassName="card-container"
            style={{
              borderTopColor: this.getColor(),
              borderBottomColor: this.getBorderBottomColor()
            }}
          >
            <div className="card-aligner">
              <div className="title" style={{ color: this.getTitleColor() }}>
                <span title={_title.length > titleSliceAt ? _title : ''}>
                  {title}
                </span>
                <div className="subtitle">{subtitle}</div>
              </div>

              <div className="card-wrapper">
                {platformID !== 'CO' && (
                  <div className="site-title">{site_titleFormatted}</div>
                )}

                <div className="type">{translations[type] || type}</div>

                <div className="authors">
                  {authors.join(', ')}
                  {supAuthors}
                </div>

                <div className="date-zone">{date}</div>
              </div>
            </div>

            {renderAvail()}
          </CustomView>

          <CustomView
            condition={isMobileOnly}
            viewClassName="card-container"
            style={{ borderColor: this.getColor() }}
          >
            <div className="authors">
              {authors.join(', ')}
              {supAuthors}
            </div>

            <br />

            <div className="title" style={{ color: this.getTitleColor() }}>
              {title}
            </div>
            <div className="subtitle">{_subtitle}</div>
          </CustomView>

          <div>
            {overview !== null || isMobileOnly ? (
              <button
                className="read read--button"
                onClick={this.handleClickOverview}
              >
                <div>
                  {isMobileOnly ? (
                    <FormattedMessage id="resultCard.more_info" />
                  ) : (
                    <FormattedMessage id="resultCard.read_overview" />
                  )}{' '}
                </div>
                <div
                  className="icon-animate"
                  style={{
                    transform: displayOverview
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)'
                  }}
                >
                  <ReactSVG svgStyle={svgStyle} src={ChevronOuvre} />
                </div>
              </button>
            ) : (
              <div style={{ minHeight: 43 }} />
            )}

            <div
              style={{
                borderColor: this.getColor(),
                display: displayOverview ? 'block' : 'none'
              }}
              className="overview"
            >
              <CustomView condition={isMobileOnly}>
                <div>{site_titleFormatted}</div>
                <div className="type">{type}</div>
                <div>{date}</div>
                <br />
                {this.props.platformID === 'OB' && renderAvail()}
                <br />
                <div className="overview-div">
                  {overview !== null && (
                    <FormattedMessage id="resultCard.overview" />
                  )}
                </div>
              </CustomView>
              {overview}
            </div>
          </div>
        </a>
      </Wrapper>
    );
  }
}

export default connect(
  ({ translations: { translations } }) => ({ translations }),
  () => ({})
)(ResultCard);



// WEBPACK FOOTER //
// ./src/components/ResultCard/index.js